import { type Key } from 'swr'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  type CartControllerAddResponse,
  CartControllerV4ApiFactory,
  type PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { useBullyApi } from '../../../base-api-communication'
import { useGlobalConfigContext } from '../../../global-config'

const getCartIntermediateApiSwrProductAddToCartKey = (): Key => {
  return 'cartIntermediateApiSwrProductAddToCart'
}

export type CartIntermediateAddToCartProps = {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  offerId?: string
  quantity: number
}

export const useCartIntermediateApiSwrProductAddToCartMutation = ({
  currentPrescriptionType,
  offerId,
  quantity,
}: CartIntermediateAddToCartProps): SWRMutationResponse<CartControllerAddResponse | null> => {
  const config = useGlobalConfigContext()
  const client = useBullyApi(CartControllerV4ApiFactory)

  const fetcher = async (): Promise<CartControllerAddResponse | null> => {
    if (!offerId) {
      return null
    }

    const payload = {
      Accept_Language: config.locale,
      CartV2CartEntryRequestV1: {
        offerId,
        prescriptionType: currentPrescriptionType,
        quantity,
      },
      language: config.language,
      tenant: config.tenantAndEnv,
    }

    const response =
      await client.cartServiceCartPostAddToCartEntryLocalized(payload)

    return response.data
  }

  return useSWRMutation(getCartIntermediateApiSwrProductAddToCartKey(), fetcher)
}
